// @ts-check

/**
 * Enumerated type for sale listings statuses.
 * @type {typeof import('@erpagroapp/types').TipoComponentePersonalizacion}
 */
export const TipoComponentePersonalizacion = Object.freeze({
  Boton: 0,
  Texto: 1,
  Tabla: 2,
  Concatenacion: 3,
  Flag: 4,
});
